import React from 'react'
import * as S from './styled'
import type { Props, SupportedHTMLElement } from './types'

const supportedHTMLElements: SupportedHTMLElement[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'legend']

export const Heading = ({ type, weight = 'regular', asTag, children, ...props }: Props) => {
  const getType = (): SupportedHTMLElement | 'div' => {
    if (asTag) {
      return asTag
    }

    if (supportedHTMLElements.find((element) => element === type)) {
      return type as SupportedHTMLElement
    }

    return 'div'
  }

  return (
    <S.Container as={getType()} $type={type} $weight={weight} data-testid="Heading" {...props}>
      {children}
    </S.Container>
  )
}
